<app-loading *ngIf="isLoading == false; else hideLoading"></app-loading>
<ng-template #hideLoading>
  <app-header-photo [data]="photoHeader" [totalQty]="totalQty"></app-header-photo>
  <app-upload-photo *ngIf="this.photoModel.length == 0"></app-upload-photo>
  <app-list-photo *ngIf="this.photoModel.length > 0" [data]="photoModel"></app-list-photo>
</ng-template>